import React from 'react';
import { Mail, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[rgb(26,28,30)] border-t border-[rgba(255,255,255,0.1)] py-16 px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/eshwald-icon.jpg" 
                alt="Eshwald Ops Icon" 
                className="h-10 w-10 rounded-lg object-cover"
              />
              <div className="text-2xl font-bold">
                <span className="text-white">Eshwald</span>
                <span className="text-[rgb(197,155,47)] ml-1">Ops</span>
              </div>
            </div>
            <p className="text-[rgb(161,161,170)] mb-6 leading-relaxed max-w-[400px]">
              Empowering creators to build sustainable businesses through strategic digital product partnerships. Zero upfront cost, maximum growth potential.
            </p>
            <div className="flex space-x-3">
              <a
                href="mailto:eshwaldsystems@gmail.com"
                className="w-10 h-10 rounded-lg bg-[rgb(38,40,42)] flex items-center justify-center text-[rgb(161,161,170)] hover:bg-gradient-to-br hover:from-[rgb(197,155,47)] hover:to-[rgb(124,56,178)] hover:text-white transition-all duration-300 hover:transform hover:translate-y-[-2px] hover:scale-110"
              >
                <Mail size={18} />
              </a>
              <a
                href="https://www.instagram.com/kirantj_hanul.theoperator/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[rgb(38,40,42)] flex items-center justify-center text-[rgb(161,161,170)] hover:bg-gradient-to-br hover:from-[rgb(197,155,47)] hover:to-[rgb(124,56,178)] hover:text-white transition-all duration-300 hover:transform hover:translate-y-[-2px] hover:scale-110"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-choose-us')}
                  className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm"
                >
                  Why Choose Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Get Started</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <a
                  href="mailto:eshwaldsystems@gmail.com"
                  className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm"
                >
                  eshwaldsystems@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[rgba(255,255,255,0.1)] flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-[rgb(161,161,170)] text-sm">
            © {currentYear} Eshwald Ops. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy-policy" className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-[rgb(161,161,170)] hover:text-[rgb(197,155,47)] transition-colors duration-200 text-sm">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;